import React, { useEffect, useState, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import {
  getApproveRequestActionListed,
  SetEmployeeProfileDetailsID,
  SetISPendingDetails,
  getSideBarfilesActions,
  SetStatusBTN,
  getEmployeeListFilterPersonsListed,
  setThecountBasedRenders,
  setEditableActions,
  setTheoptions,
  setTheUserObjects, ///---User---Object
  sethtmlformatpdfdownoadActions, ////---Pdf---html----formats
  SetDashboards,
  SetTheDashboardClientList,
  setClientBranchSearchAction,
  getSingleEmployeeActions,
  setDropDownRenders,
  setTheUser_ID,
  setTheemployeeRoleId,
  setTheAllFormPdf,
  setTheTODATELISTINDASH,
  setTheFROMDATELIST,
  setRegionActions,
  setZoneActions,
  setGeoLoactionStateAction,
  setTheOnboardFromDateLIST,
  setOnboardTODtaeDASH,
  setEmployeeLstTodate,
  setTheEmployeeLISTfromdate,
  ////approve request listed
  settheLabourCasualApproveRequestEmployeelist_State,
  settheLabourCasualApproveRequestEmployeelist_Region,
  settheLabourCasualApproveRequestEmployeelist_Zone,
  settheLabourCasualApproveRequestEmployeelist_Client,
  settheLabourCasualApproveRequestEmployeelist_From_Date,
  settheLabourCasualApproveRequestEmployeelist_To_date,
  settheLabourCasualApproveRequestEmployeelist_FilterOptions,
  SettheBracnhId,
  settheJobinfoBranchEmployeeProfile,
  setTheRoleObjects,
  setTheBranchoptionsFieldAgent,
  setTheZoneObjectinEmployeeList,
  resetOrganizationFilterlist,
  settheLabourCasualApproveRequestEmployeelist_Organizations,
  // for empty
  setTheAadharBackSideImageDatas,
  setTheAadharFrontImageDatas,
  settheBankHolderName,
  settheIDverifycationanotherapidatasResponse,
  setTheAadharFristNumbers,
  setTHnUMBERSRESPONSES,
  setIDverifycationanotherapidatasReponsesError,
  setTablePositionPersist,
  getCasualApproveRequestActionListed,
  setCasualLAbourDelete,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import "../../../StyleSheet/MainComponent/Management/EmployeeList.scss";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { getBottomNavigationUtilityClass } from "@mui/material";
import Select from "react-select";
import { useInsertionEffect } from "react";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import ExcelFormatDwonload from "../Client/ExcelFormatDwonload";
import _, { values } from "lodash";
import { differenceInDays } from "date-fns";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//---icons
import excelSheetImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-15.svg";
import allformPdf from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-09.svg";
import downloadoffer from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-07.svg";
import { EmployeeListsPersonsApi } from "../../../text/apidata";
import { getLoaderAction } from "../../../Redux/Loader";
import useDebouncedEffect from "use-debounced-effect";
import dayjs from "dayjs";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";

const CasualLabourList = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist,
  );

  const dateRangeRef = useRef(null);

  const [sno, setsno] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.casualLabourListTempPage?.page == undefined
      ? 1
      : TablePositionPersist.casualLabourListTempPage.page,
  );

  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteID, setDeleteID] = useState("");
  const [search, setsearch] = useState(
    TablePositionPersist?.casualLabourListTempPage?.search == undefined ||
      TablePositionPersist?.casualLabourListTempPage?.search == ""
      ? ""
      : TablePositionPersist.casualLabourListTempPage.search,
  );

  const [nameList4, setOptions4] = useState([]);
  const [searchBranch, setSearch] = useState("");
  const [CLicktedState, setClictedState] = useState(false);
  const options = [
    { value: 0, label: "All" },
    { value: 1, label: "Kyc Completed" },
    { value: 2, label: "Kyc Pending" },
    // { value: 3, label: "Awaiting For Payroll" },
    { value: 4, label: "Awaiting For RM" },
    { value: 5, label: "Exited Employee" },
    { value: 6, label: "Expired Employee" },
  ];
  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(
    state.EmployeeVerificationsNeed
      .LabourCasualApproveRequestEmployeelist_From_Date,
  );
  var gt = convert(
    state.EmployeeVerificationsNeed
      .LabourCasualApproveRequestEmployeelist_To_date,
  );

  const FilterRenders = {
    awaiting_payroll:
      state.EmployeeVerificationsNeed
        .LabourCasualApproveRequestEmployeelist_FilterOptions?.value == 3
        ? true
        : "",
    awaiting_rm:
      state.EmployeeVerificationsNeed
        .LabourCasualApproveRequestEmployeelist_FilterOptions?.value == 4
        ? true
        : "",
    kyc_completed:
      state.EmployeeVerificationsNeed
        .LabourCasualApproveRequestEmployeelist_FilterOptions?.value == 1
        ? true
        : "",
    kyc_pending:
      state.EmployeeVerificationsNeed
        .LabourCasualApproveRequestEmployeelist_FilterOptions?.value == 2
        ? true
        : "",
    is_exited:
      state.EmployeeVerificationsNeed
        .LabourCasualApproveRequestEmployeelist_FilterOptions?.value == 5
        ? true
        : "",
    is_expired:
      state.EmployeeVerificationsNeed
        .LabourCasualApproveRequestEmployeelist_FilterOptions?.value == 6
        ? true
        : "",
  };
  const [StatusFilter, setStatusfilter] = useState(FilterRenders);

  const [FilterRenderValues, setFilterRendersInValues] = useState(
    //   {
    //   value: 0,
    //   label: "All",
    // }
    state.EmployeeVerificationsNeed
      ?.LabourCasualApproveRequestEmployeelist_FilterOptions,
  );
  const today_day = dayjs().format("YYYY-MM-DD");

  const [range, setrange] = useState(
    state.EmployeeVerificationsNeed
      .LabourCasualApproveRequestEmployeelist_To_date == ""
      ? [today_day, today_day]
      : [it, gt],
  );
  // console.log(state.EmployeeVerificationsNeed.LabourCasualApproveRequestEmployeelist_To_date ,"LabourCasualApproveRequestEmployeelist_To_date");

  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);

  const [datas, setData] = useState({
    zone: state.EmployeeVerificationsNeed
      .LabourCasualApproveRequestEmployeelist_Zone?.value,
    state:
      state.EmployeeVerificationsNeed
        .LabourCasualApproveRequestEmployeelist_State?.value,
    region:
      state.EmployeeVerificationsNeed
        .LabourCasualApproveRequestEmployeelist_Region?.value,
  });

  console.log(
    state.EmployeeVerificationsNeed
      .LabourCasualApproveRequestEmployeelist_State,
    "fsdjksdjfjksdjfs",
  );
  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(
        settheLabourCasualApproveRequestEmployeelist_From_Date(range[0]),
      );
      dispatch(settheLabourCasualApproveRequestEmployeelist_To_date(range[1]));
    }
    if (
      state.EmployeeVerificationsNeed
        .LabourCasualApproveRequestEmployeelist_To_date == ""
    ) {
      dispatch(
        settheLabourCasualApproveRequestEmployeelist_From_Date(today_day),
      );
      dispatch(settheLabourCasualApproveRequestEmployeelist_To_date(today_day));
    }
  }, [range]);

  const [multiselect, setMuliselect] = useState(
    state.EmployeeVerificationsNeed
      .LabourCasualApproveRequestEmployeelist_State,
  );
  const [multiselect1, setMuliselect1] = useState(
    state.EmployeeVerificationsNeed
      .LabourCasualApproveRequestEmployeelist_Region,
  );
  const [multiselect3, setMuliselect3] = useState(
    state.EmployeeVerificationsNeed.LabourCasualApproveRequestEmployeelist_Zone,
  );

  const [nameList5, setOptions5] = useState([]);
  const [ClientId, setClientID] = useState({
    client:
      state.EmployeeVerificationsNeed
        .LabourCasualApproveRequestEmployeelist_Client?.value,
  });

  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    organization_search: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    Clientsearch: "",
    organization_search: "",
  };

  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch,
  );
  const [Filterids, setfilterids] = useState({
    organization:
      state.EmployeeVerificationsNeed
        .LabourCasualApproveRequestEmployeelist_Organizations?.value,
  });
  const [Organization_Val, setOrganization_Val] = useState(
    state.EmployeeVerificationsNeed
      .LabourCasualApproveRequestEmployeelist_Organizations,
  );
  const [Organization_options, setOrganizations_options] = useState([]);

  useEffect(() => {
    dispatch(setEditableActions(1));
  }, []);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    setdtPageindex(1);
    setClientID({
      ...ClientId,
      client: "",
    });
    dispatch(
      settheLabourCasualApproveRequestEmployeelist_Client({
        value: "",
        label: "ALL",
      }),
    );
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setMuliselect3({ value: "", label: "ALL" });

      dispatch(
        settheLabourCasualApproveRequestEmployeelist_Region(selectedVal),
      );
      dispatch(
        settheLabourCasualApproveRequestEmployeelist_Zone({
          value: "",
          label: "ALL",
        }),
      );

      setData({
        ...datas,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setData({
        ...datas,
        region: "",
        zone: "",
      });

      dispatch(
        settheLabourCasualApproveRequestEmployeelist_Region({
          value: "",
          label: "ALL",
        }),
      );

      dispatch(
        settheLabourCasualApproveRequestEmployeelist_Zone({
          value: "",
          label: "ALL",
        }),
      );

      setMuliselect3({ value: "", label: "ALL" });

      setMuliselect1({ value: "", label: "ALL" });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    setdtPageindex(1);
    setClientID({
      ...ClientId,
      client: "",
    });
    dispatch(
      settheLabourCasualApproveRequestEmployeelist_Client({
        value: "",
        label: "ALL",
      }),
    );
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...datas,
        zone: selectedVal.value,
      });
      dispatch(settheLabourCasualApproveRequestEmployeelist_Zone(selectedVal));
    }
    if (selectedVal == null) {
      setData({
        ...datas,
        zone: "",
      });
      dispatch(
        settheLabourCasualApproveRequestEmployeelist_Zone({
          value: "",
          label: "ALL",
        }),
      );

      setMuliselect3({ value: "", label: "ALL" });
    }
  };

  const handleSelectChange = (selectedVal) => {
    setClientID({
      ...ClientId,
      client: "",
    });
    dispatch(
      settheLabourCasualApproveRequestEmployeelist_Client({
        value: "",
        label: "ALL",
      }),
    );

    pageindex(1);
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(settheLabourCasualApproveRequestEmployeelist_State(selectedVal));
      // dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
      dispatch(
        settheLabourCasualApproveRequestEmployeelist_Region({
          value: "",
          label: "ALL",
        }),
      );
      dispatch(
        settheLabourCasualApproveRequestEmployeelist_Zone({
          value: "",
          label: "ALL",
        }),
      );
      setData({
        ...datas,
        state: selectedVal.value,
        region: "",
        zone: "",
      });

      // dispatch(getSingleEmployeeActions(""));
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...datas,
        state: "",
        zone: "",
        region: "",
      });
      dispatch(
        settheLabourCasualApproveRequestEmployeelist_State({
          value: "",
          label: "ALL",
        }),
      );

      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
      // dispatch(getSingleEmployeeActions(""));
    }
  };

  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
          organization_search: SearchDebounance.organization_search,
        });
        setSearch(SearchDebounance.Clientsearch);
      }
    },
    500,
    [SearchDebounance],
  );

  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,
    });
  };

  ///---Region-----------------
  const handleInputRegion = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
    });
  };
  ///----Zone---Name
  const handleInputZone = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      zoneSearch: Val,
    });
  };
  const handlOrganizationList = (selected) => {
    if (selected != null) {
      dispatch(
        settheLabourCasualApproveRequestEmployeelist_Organizations(selected),
      );
      setOrganization_Val(selected);
      setfilterids({
        ...Filterids,
        organization: selected?.value,
      });
    } else {
      dispatch(
        settheLabourCasualApproveRequestEmployeelist_Organizations({
          value: "",
          label: "ALL",
        }),
      );
      setOrganization_Val({ value: "", label: "ALL" });
      setfilterids({
        ...Filterids,
        organization: "",
      });
    }
    setClientID({
      ...ClientId,
      client: "",
    });
    dispatch(
      settheLabourCasualApproveRequestEmployeelist_Client({
        value: "",
        label: "ALL",
      }),
    );
    dispatch(getSingleEmployeeActions("")); /// branch=---list
  };

  const handleInputOrganization = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      organization_search: Val,
    });
  };

  useEffect(() => {
    // if(datas.state !="" && datas.region !="" && datas.zone !=""){
    const payload = {
      search: searchBranch,
      page_size: 20,
      page: 1,
      data: datas,
      organization: Filterids?.organization,
    };
    setTimeout(() => {
      dispatch(setClientBranchSearchAction(payload));
    }, 400);
    // }
  }, [searchBranch, datas, Filterids]);

  const HandleInputBranch = (e) => {
    setSearchDebounance({
      ...SearchDebounance,
      Clientsearch: e,
    });
  };
  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.BranchSearchpart.BranchSearch.forEach((element) => {
        console.log(element, "asdpuaposdi element");

        objectArray.push({
          value: element.id,
          label: element.branch_code
            ? `${element.branch_code}-${element.client_name.toUpperCase()}`
            : element.client_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch]);

  //--EXCELSHEET----UPLOAD----------------

  const [ExcelSheeTFORKYCPopup, setExcelSheetFORKYCPopup] = useState(false);
  const [getidforupload, setidforuploaddata] = useState({
    client_id: "",
    user_id: "",
  });

  ///--------------Organizations-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.organization_search,
      page_size: 20,
      page: 1,
    };
    dispatch(resetOrganizationFilterlist(payloads));
  }, [SearchedVal.organization_search]);

  useEffect(() => {
    if (state.organization_filterlist_tocall.Organization_filterlist_records) {
      let ObjectArrayFormager = [];
      ObjectArrayFormager.push({
        value: "",
        label: "ALL",
      });
      state.organization_filterlist_tocall.Organization_filterlist_records.forEach(
        (element) => {
          ObjectArrayFormager.push({
            value: element.id,
            label: element.organization_name,
          });
        },
      );
      setOrganizations_options(ObjectArrayFormager);
    }
  }, [
    state.organization_filterlist_tocall.Organization_filterlist_records,
    SearchedVal.organization_search,
  ]);

  ///--------------State-----------------
  useEffect(() => {
    //  if(CLicktedState == true){
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    // setTimeout(() => {
    dispatch(setGeoLoactionStateAction(payloads));
    // }

    // }, 600);
  }, [SearchedVal.stateSearch]);

  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: datas.region,
    };
    dispatch(setZoneActions(payloads));
  }, [datas.region, SearchedVal.zoneSearch]);
  useEffect(() => {
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions5(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    if (datas.state != "") {
      const payloads = {
        search: SearchedVal.regionSearch,
        page_size: 20,
        page: 1,
        counts: 1, //-----only we ----get----the----selected regions , the--id only
        state: datas.state,
      };
      setTimeout(() => {
        dispatch(setRegionActions(payloads));
      }, 600);
    }
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
  }, [datas.state, SearchedVal.regionSearch]);
  useEffect(() => {
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });

      // console.log(objectArray , "objectArray");
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      console.log(range, "12301293-0range");

      const payloads = {
        search: search,
        page_size: 20,
        page: dtpageindex,
        // page: currentPage,

        client: ClientId.client,
        from_date: range[0],
        to_date: range[1],
        range: true,
        state: datas.state,
        region: datas.region,
        zone: datas.zone,
        awaiting_payroll: StatusFilter.awaiting_payroll,
        awaiting_rm: StatusFilter.awaiting_rm,
        is_exited: StatusFilter.is_exited,
        is_expired: StatusFilter.is_expired,
        kyc_completed: true,
        kyc_pending: StatusFilter.kyc_pending,
        organization: Filterids?.organization,
      };

      // if (
      //   state.ApproverequestDatass.Inquriy.length == 0 ||
      //   TablePositionPersist?.approveRequesTempPage?.page != dtpageindex ||
      //   TablePositionPersist?.approveRequesTempPage?.search != search ||
      //   TablePositionPersist?.approveRequesTempPage?.client != ClientId.client ||
      //   TablePositionPersist?.approveRequesTempPage?.from_date != range[0] ||
      //   TablePositionPersist?.approveRequesTempPage?.to_date != range[1] ||
      //   TablePositionPersist?.approveRequesTempPage?.state != datas.state ||
      //   TablePositionPersist?.approveRequesTempPage?.zone != datas.zone ||
      //   TablePositionPersist?.approveRequesTempPage?.region != datas.region ||
      //   TablePositionPersist?.approveRequesTempPage?.awaiting_payroll !=
      //     StatusFilter.awaiting_payroll ||
      //   TablePositionPersist?.approveRequesTempPage?.awaiting_rm !=
      //     StatusFilter.awaiting_rm ||
      //   TablePositionPersist?.approveRequesTempPage?.kyc_completed !=
      //     StatusFilter.kyc_completed ||
      //   TablePositionPersist?.approveRequesTempPage?.kyc_pending !=
      //     StatusFilter.kyc_pending ||
      //     TablePositionPersist?.approveRequesTempPage?.isApproved
      // ) {

      dispatch(getCasualApproveRequestActionListed(payloads));
      dispatch(
        setTablePositionPersist({
          data: payloads,
          pageName: "casualLabourListTempPage",
        }),
      );
      // }
      currentRef.current.scrollTop = sessionStorage.getItem(
        "approverequestempTableScrollPosition",
      );
    }
  }, [
    dtpageindex,
    range,
    StatusFilter,
    // state.ClientBranchIDs.SingelEmployeelistes,
    datas,
    search,
    ClientId,
    Filterids,
  ]);

  console.log(
    state.ApproverequestDatass.Inquriy.length == 0 ||
      TablePositionPersist?.casualLabourListTempPage?.page != dtpageindex ||
      TablePositionPersist?.casualLabourListTempPage?.search != search ||
      TablePositionPersist?.casualLabourListTempPage?.client !=
        ClientId.client ||
      TablePositionPersist?.casualLabourListTempPage?.from_date != range[0] ||
      TablePositionPersist?.casualLabourListTempPage?.to_date != range[1] ||
      TablePositionPersist?.casualLabourListTempPage?.state != datas.state ||
      TablePositionPersist?.casualLabourListTempPage?.zone != datas.zone ||
      TablePositionPersist?.casualLabourListTempPage?.region != datas.region ||
      TablePositionPersist?.casualLabourListTempPage?.awaiting_payroll !=
        StatusFilter.awaiting_payroll ||
      TablePositionPersist?.casualLabourListTempPage?.awaiting_rm !=
        StatusFilter.awaiting_rm ||
      TablePositionPersist?.casualLabourListTempPage?.kyc_completed !=
        StatusFilter.kyc_completed ||
      TablePositionPersist?.casualLabourListTempPage?.kyc_pending !=
        StatusFilter.kyc_pending ||
      TablePositionPersist?.casualLabourListTempPage?.isApproved,
    "aosyiOAUSa s",
  );

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);
  }
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    [],
  );
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const handleEmployeeDetails = (id) => {
    console.log(id, "ijdsdjsdjsdjsjd");
    navigate(`/casualemployeeprofile/${id.id}`);
  };
  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const handleDeleteActions = (id) => {
    const targetId = id || deleteID;
    console.log(id, "ffjjfjhkhjkjhkh");
    if (targetId != "") {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to delete this casual labour?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#234492",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        console.log(result, "djdjkajkdjkjka");
        if (result.isConfirmed) {
          const payloads = {
            search: search,
            page_size: 20,
            page: dtpageindex,
            client: ClientId.client,
            from_date: range[0],
            to_date: range[1],
            range: true,
            state: datas.state,
            region: datas.region,
            zone: datas.zone,
            // awaiting_payroll: StatusFilter.awaiting_payroll,
            // awaiting_rm: StatusFilter.awaiting_rm,
            // is_exited: StatusFilter.is_exited,
            // is_expired: StatusFilter.is_expired,
            kyc_completed: true,
            // kyc_pending: StatusFilter.kyc_pending,
            organization: Filterids?.organization,
          };

          console.log(result, "1112221121");
          const deletePayload = {
            DeleteID: targetId,
            Functions: () => {
              dispatch(getCasualApproveRequestActionListed(payloads));
              setDeleteID("");
            },
          };
          dispatch(setCasualLAbourDelete(deletePayload));
        }
      });
    }
  };

  const columns = [
    {
      Header: "Tnx Id",
      accessor: "",
      Cell: (row) => {
        if (row.row.original.id != undefined && row.row.original.id != null) {
          const userId = row.row.original.id;
          const lastFourDigits = userId.slice(-6);
          return <p className="m-0">{lastFourDigits}</p>;
        }
      },
    },
    //        {
    //   Header: "U-ID",
    //   accessor: "user_id.local_uid",
    //   Cell: ({ row }) => {
    //     const userId = row.original?.user_id?.local_uid;

    //     // Handle null, undefined, empty string, or whitespace
    //     const displayValue =
    //       userId == null || String(userId).trim() == "" ? "--" : userId;

    //     return <p className="PTAGs">{displayValue}</p>;
    //   },
    // },

    // {
    //   Header: "Employee Code",
    //   accessor: "",
    //   Cell: (row) => {
    //     return (
    //       <>
    //         <div className="UserName" style={{ cursor: "pointer" }}>
    //           <div className="">
    //             <span>
    //               {row.row.original.user_id?.user_uid != null &&
    //               row.row.original.user_id?.user_uid != undefined &&
    //               row.row.original.user_id?.user_uid != ""
    //                 ? row.row.original.user_id?.user_uid
    //                 : "--"}
    //             </span>
    //           </div>
    //         </div>
    //       </>
    //     );
    //   },
    // },

    {
      Header: "Employee Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="UserName" style={{ cursor: "pointer" }}>
              <div className="">
                {row.row.original.first_name != undefined &&
                row.row.original.first_name != null &&
                row.row.original.first_name != "" ? (
                  <span>
                    {capitalizeFirstLetter(row.row.original.first_name)}
                  </span>
                ) : (
                  <>--</>
                )}
              </div>
            </div>
          </>
        );
      },
    },

    //         {
    //           Header: "Onboarder Details",
    //           accessor: "",
    //           Cell: (row) => {
    //             const approvedStatus = row.row.original.approved_status;

    //             if (approvedStatus && approvedStatus.length > 0) {
    //               const onboarder = approvedStatus.find(
    //                 (item) => item.user_type === "onboard"
    //               );

    //               if (
    //                 onboarder &&
    //                 onboarder.create_user &&
    //                 onboarder.create_user.email
    //               ) {
    //                 return (
    //                   <div className="UserName ">
    //                     <span
    //                     id="list-ToolTips"
    //                       data-tooltip-id="list-ToolTips"
    //                       data-tooltip-content={`${onboarder.create_user.email}`}

    //                     >
    // <>{onboarder.create_user.email}</>
    //                     </span>
    //                   </div>
    //                 );
    //               }
    //             }

    //             return (
    //               <div className="UserName">
    //                 <span>---</span>
    //               </div>
    //             );
    //           },
    //         },
    {
      Header: "Onboarder Details",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="">
              {row.row.original?.created_by?.email || "--"}
            </div>
          </>
        );
      },
    },
    {
      Header: "Mobile",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original != null &&
            row.row.original.phone_number != null &&
            row.row.original.phone_number != "" &&
            row.row.original.phone_number != undefined ? (
              <>
                {row.row.original.phone_number != undefined ? (
                  <div className="UserName">
                    <span className="KYcRoles">
                      {row.row.original.phone_number}
                    </span>
                  </div>
                ) : (
                  <div className="UserName">
                    <span className="KYcRoles">---</span>
                  </div>
                )}
              </>
            ) : (
              <div className="UserName">
                <span className="KYcRoles">{"----"}</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <p className="PTAGs">
              {`${
                row.row.original.created_at.slice(0, 10)
                // +
                // "  " +
                // formattedTime
              }`}
            </p>
          </>
        );
      },
    },

    // {
    //   Header: "Branch",
    //   accessor: "",
    //   Cell: (row) => {
    //     return (
    //       <>
    //         {row.row.original.client_id != null &&
    //         row.row.original.client_id != undefined &&
    //         row.row.original.client_id.client_name != "" &&
    //         row.row.original.client_id.client_name != undefined ? (
    //           <div className="UserName">
    //             <span
    //               data-tooltip-id="list-ToolTips"
    //               data-tooltip-content={`${row.row.original.client_id.client_name}`}
    //             >
    //               {row.row.original.client_id.client_name.length > 12 ? (
    //                 <>
    //                   {row.row.original.client_id.client_name.slice(0, 12)}
    //                   ...
    //                 </>
    //               ) : (
    //                 <>{row.row.original.client_id.client_name}</>
    //               )}
    //             </span>
    //           </div>
    //         ) : (
    //           <div className="UserName">
    //             <span>---</span>
    //           </div>
    //         )}
    //       </>
    //     );
    //   },
    // },
    // {
    //   Header: "Branch",
    //   accessor: "",
    //   Cell: (row) => {
    //     const [showTooltip, setShowTooltip] = useState(false);

    //     return (
    //       <>
    //         {row.row.original.client_id != null &&
    //         row.row.original.client_id != undefined &&
    //         row.row.original.client_id.client_name != "" &&
    //         row.row.original.client_id.client_name != undefined ? (
    //           <div className="UserName"
    //             onMouseEnter={() => setShowTooltip(true)}
    //             onMouseLeave={() => setShowTooltip(false)}
    //             style={{ position: 'relative' }}
    //           >
    //             <span>
    //               {row.row.original.client_id.client_name.length > 12 ? (
    //                 <>
    //                   {row.row.original.client_id.client_name.slice(0, 12)}...
    //                 </>
    //               ) : (
    //                 <>{row.row.original.client_id.client_name}</>
    //               )}
    //             </span>

    //             {/* Custom tooltip */}
    //             {showTooltip && (
    //               <div className="custom-tooltip">
    //                 {row.row.original.client_id.client_name}
    //               </div>
    //             )}
    //           </div>
    //         ) : (
    //           <div className="UserName">
    //             <span>---</span>
    //           </div>
    //         )}
    //       </>
    //     );
    //   },
    // },

    {
      Header: "Branch",
      accessor: "",
      Cell: (row) => {
        const [showTooltip, setShowTooltip] = useState(false);

        const client = row?.row?.original?.client_id;
        const branchCode = client?.branch_code ?? "";
        const clientName = client?.client_name ?? "";

        // Full label for tooltip
        const fullLabel = branchCode
          ? `${branchCode} - ${clientName}`
          : clientName;

        // Short display (truncate client name only)
        const shortName =
          clientName.length > 12 ? `${clientName.slice(0, 12)}...` : clientName;

        const shortLabel = branchCode
          ? `${branchCode} - ${shortName}`
          : shortName;

        return (
          <>
            {client && clientName ? (
              <div
                className="UserName"
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                style={{ position: "relative" }}
              >
                <span>{shortLabel}</span>

                {showTooltip && (
                  <div className="custom-tooltip">{fullLabel}</div>
                )}
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    // {
    //   Header: "Zone",
    //   accessor: "",
    //   Cell: (row) => {
    //     return (
    //       <>
    //         {row.row.original.user_id != null &&
    //         row.row.original.user_id.zone_id != null &&
    //         row.row.original.user_id.zone_id != undefined ? (
    //           <>
    //             {row.row.original.user_id.zone_id != undefined && row.row.original.user_id.zone_id.length >  0 ? (
    //               <div className="UserName">
    //                 <span className="PTAGs">
    //                   {/* {row.row.original.user_id.zone_id.zone_name} */}

    //                   {row.row.original.user_id.zone_id.map((item) => {
    //                     return (
    //                       <>
    //                         {item.zone_name.length > 10 ? (
    //                           <p
    //                             data-tooltip-id="list-ToolTips"
    //                             data-tooltip-content={item.zone_name}
    //                             className="PTAGs"
    //                           >
    //                             {item.zone_name.slice(0, 8)}...
    //                           </p>
    //                         ) : (
    //                           <p
    //                             data-tooltip-id="list-ToolTips"
    //                             data-tooltip-content={item.zone_name}
    //                           >
    //                             {item.zone_name}
    //                           </p>
    //                         )}
    //                       </>
    //                     );
    //                   })}
    //                 </span>
    //               </div>
    //             ) : (
    //               <div className="UserName PTAGs">
    //                 <span>---</span>
    //               </div>
    //             )}
    //           </>
    //         ) : (
    //           <div className="UserName PTAGs">
    //             <span>{"----"}</span>
    //           </div>
    //         )}
    //       </>
    //     );
    //   },
    // },
    {
      Header: "Zone",
      accessor: "",
      Cell: (row) => {
        const [hoveredIndex, setHoveredIndex] = useState(null); // Keep track of which zone is being hovered over

        return (
          <>
            {row.row.original != null &&
            row.row.original.zone_id != null &&
            row.row.original.zone_id != undefined ? (
              <>
                {row.row.original.zone_id ? (
                  <div className="UserName">
                    <span className="PTAGs">
                      {row.row.original.zone_id.zone_name}
                    </span>
                  </div>
                ) : (
                  <div className="UserName PTAGs">
                    <span>---</span>
                  </div>
                )}
              </>
            ) : (
              <div className="UserName PTAGs">
                <span>{"----"}</span>
              </div>
            )}
          </>
        );
      },
    },
    {
      Header: "Onboarding Status",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div>
              {row.row.original.is_pending
                ? "Awaiting for RM"
                : "KYC Completed"}
            </div>
          </>
        );
      },
    },
    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  setDeleteID(row.row.original.id);
                  handleDeleteActions(row.row.original.id);
                }}
              >
                <span className="OuterActionSpan">
                  <span className="EditImages">
                    <img src={DeleteImages} />
                  </span>

                  <span className="ActionsList"> Delete </span>
                </span>
              </button>
            </div>
          </>
        );
      },
    },

    //         {
    //           Header: "Status",
    //           accessor: "",
    //           Cell: (row) => {

    //             return (
    //               <>
    //                 {/* ////-----------------Decline---Status------For is_decline as   have to -true */}
    //                 {row.row.original.is_decline ? (
    //                   <div className="StatusList">
    //                     <div className="DeclineStatus">
    //                       <span>x</span>
    //                     </div>
    //                     <span>Decline</span>
    //                   </div>
    //                 ) : (
    //                   <>
    //                     {/* ////-----------------Approvel---Status------For Decline , is_pending  have to false and job_description.letter_id is should not
    //                  be undefined
    //                 */}
    //                     {!row.row.original.is_pending &&
    //                     !row.row.original.is_decline &&
    //                     row.row.original.job_description != undefined &&
    //                     row.row.original.job_description.letter_id != undefined &&
    //                     row.row.original.job_description.letter_id.media_url !=
    //                       undefined ? (
    //                       <div className="StatusList">
    //                         <img src={correctIcons} />
    //                         <span>Approved</span>

    //                         {row.row.original.job_description != undefined &&
    //                         row.row.original.job_description.letter_id !=
    //                           undefined &&
    //                         row.row.original.job_description.letter_id.media_url !=
    //                           undefined ? (
    //                          <>
    //                             {/* <i class="fa-solid fa-download"></i> */}
    //                             <span  className="AllformExcel"
    //                                 data-tooltip-id="list-ToolTips"
    //                                data-tooltip-content="Offer letter"
    //                                  style={{ zIndex: "0" }}
    //                                                         onClick={(e) => {
    //                                                           e.stopPropagation();
    //                                                           window.open(
    //                                                             row.row.original.job_description.letter_id
    //                                                               .media_url,
    //                                                             "_blank"
    //                                                           );
    //                                                         }}

    //                             >
    //                                 <img src={downloadoffer}/>
    //                               </span>
    //                            </>
    //                         ) :
    //                         null

    //                         }

    //                         {row.row.original != undefined &&
    //                         row.row.original.user_id != undefined &&
    //                         row.row.original.user_id != null ? (
    //                           // /---pdf---format----downloads
    //                           // <i
    //                           //   class="fa-regular fa-file-pdf"
    //                           //   data-tooltip-id="list-ToolTips"
    //                           //   data-tooltip-content="All form pdf"
    //                           //   style={{ zIndex: "0" }}
    //                           //   onClick={(e) => {
    //                           //     e.stopPropagation();
    //                           //     const payload = {
    //                           //       id: row.row.original.user_id.id,
    //                           //       count: 1,
    //                           //     };
    //                           //     dispatch(sethtmlformatpdfdownoadActions(payload));
    //                           //   }}
    //                           // ></i>

    //                           <span  className="AllformExcel"

    //                           data-tooltip-id="list-ToolTips"
    //                           data-tooltip-content="All form pdf"
    //                           style={{ zIndex: "0" }}
    //                           onClick={(e) => {
    //                             e.stopPropagation();
    //                             const payload = {
    //                               id: row.row.original.user_id.id,
    //                               count: 1,
    //                             };
    //                             dispatch(sethtmlformatpdfdownoadActions(payload));
    //                           }}
    //                           >
    //                           <img src={allformPdf}/>
    //                         </span>

    //                         ) :
    //  null
    //                         }

    //                         <>
    //                           {row.row.original.user_id != undefined &&
    //                           row.row.original.user_id.id != undefined &&
    //                           row.row.original.user_id.id != null ? (
    //                             <div
    //                               style={{
    //                                 display: "flex",
    //                                 justifyContent: "center",
    //                                 alignItems: "center",
    //                               }}
    //                               data-tooltip-id="list-ToolTips"
    //                               data-tooltip-content="Excel export"
    //                               onClick={(e) => {
    //                                 e.stopPropagation();
    //                                 setidforuploaddata({
    //                                   ...getidforupload,
    //                                   user_id: row.row.original.user_id.id,
    //                                   client_id: "",
    //                                 });
    //                                 setExcelSheetFORKYCPopup(true);
    //                               }}
    //                             >
    //                               {/* <i class="fa-solid fa-sheet-plastic"></i> */}
    //                               <span  className="AllformExcel">
    //                                 <img src={excelSheetImage}/>
    //                               </span>
    //                             </div>
    //                           ) : (
    //                             <div
    //                               style={{
    //                                 display: "flex",
    //                                 justifyContent: "center",
    //                                 alignItems: "center",
    //                               }}
    //                             >
    //                               <span>{"-----"}</span>
    //                             </div>
    //                           )}
    //                         </>
    //                       </div>
    //                     ) : (
    //                       <>
    //                         {/* ////-----------------Pending---Status------For is_pending  have to -true */}
    //                         {row.row.original.is_pending ? (
    //                           <div className="StatusList">
    //                             <img src={Pendingimg} />
    //                             <span>Pending</span>
    //                             <></>
    //                           </div>
    //                         ) : (
    //                           <>
    //                             {/* ////-----------------completed---Status------For  Decline , is_pending  have to false */}
    //                             {!row.row.original.is_pending &&
    //                             !row.row.original.is_decline ? (
    //                               <div className="StatusList">
    //                                 {/* <img src={correctIcons} />
    //                                 <span>Completed</span> */}
    //                                 <span>{"---"}</span>
    //                               </div>
    //                             ) : null}
    //                           </>
    //                         )}
    //                       </>
    //                     )}
    //                   </>
    //                 )}
    //               </>
    //             );
    //           },
    //         },
    // {
    //   Header: "Status",
    //   accessor: "",
    //   Cell: (row) => {
    //     const [hovered, setHovered] = useState(null); // Hover state for tooltips
    //     const isExited = row.row.original?.is_exited;
    //     if (isExited) {
    //       return (
    //         <p className="m-0" style={{ color: "#d9534f", fontWeight: 600 }}>
    //           Exited
    //         </p>
    //       );
    //     }

    //     return (
    //       <>
    //         {/* Decline Status */}
    //         {row.row.original.is_decline ? (
    //           <div className="StatusList">
    //             <div className="DeclineStatus">
    //               <span>x</span>
    //             </div>
    //             <span>Decline</span>
    //           </div>
    //         ) : (
    //           <>
    //             {/* Approved Status */}
    //             {!row.row.original.is_pending &&
    //             !row.row.original.is_decline &&
    //             row.row.original.job_description?.letter_id?.media_url ? (
    //               <div className="StatusList">
    //                 <img src={correctIcons} alt="Approved" />
    //                 <span>Approved</span>

    //                 {/* Offer Letter Download */}
    //                 <span
    //                   className="AllformExcel"
    //                   style={{ position: "relative" }}
    //                   onMouseEnter={() => setHovered("offer-letter")}
    //                   onMouseLeave={() => setHovered(null)}
    //                   onClick={(e) => {
    //                     e.stopPropagation();
    //                     window.open(
    //                       row.row.original.job_description.letter_id.media_url,
    //                       "_blank",
    //                     );
    //                   }}
    //                 >
    //                   <img src={downloadoffer} alt="Download Offer Letter" />
    //                   {hovered === "offer-letter" && (
    //                     <div className="custom-tooltip">Offer Letter</div>
    //                   )}
    //                 </span>

    //                 {/* All Form PDF Download */}
    //                 {row.row.original?.user_id?.id && (
    //                   <span
    //                     className="AllformExcel"
    //                     style={{ position: "relative" }}
    //                     onMouseEnter={() => setHovered("all-pdf")}
    //                     onMouseLeave={() => setHovered(null)}
    //                     onClick={(e) => {
    //                       e.stopPropagation();
    //                       const payload = {
    //                         id: row.row.original.user_id.id,
    //                         count: 1,
    //                       };
    //                       dispatch(sethtmlformatpdfdownoadActions(payload));
    //                     }}
    //                   >
    //                     <img src={allformPdf} alt="All Form PDF" />
    //                     {hovered === "all-pdf" && (
    //                       <div className="custom-tooltip">All form PDF</div>
    //                     )}
    //                   </span>
    //                 )}

    //                 {/* Excel Export */}
    //                 {row.row.original?.user_id?.id && (
    //                   <div
    //                     style={{
    //                       display: "flex",
    //                       justifyContent: "center",
    //                       alignItems: "center",
    //                       position: "relative",
    //                     }}
    //                     onMouseEnter={() => setHovered("excel-export")}
    //                     onMouseLeave={() => setHovered(null)}
    //                     onClick={(e) => {
    //                       e.stopPropagation();
    //                       setidforuploaddata({
    //                         ...getidforupload,
    //                         user_id: row.row.original.user_id.id,
    //                         client_id: "",
    //                       });
    //                       setExcelSheetFORKYCPopup(true);
    //                     }}
    //                   >
    //                     <span className="AllformExcel">
    //                       <img src={excelSheetImage} alt="Excel Export" />
    //                       {hovered === "excel-export" && (
    //                         <div
    //                           className="custom-tooltip"
    //                           style={{ left: "0" }}
    //                         >
    //                           Excel Export
    //                         </div>
    //                       )}
    //                     </span>
    //                   </div>
    //                 )}
    //               </div>
    //             ) : (
    //               <>
    //                 {/* Pending Status */}
    //                 {row.row.original.is_pending ? (
    //                   <div className="StatusList">
    //                     <img src={Pendingimg} alt="Pending" />
    //                     <span>Pending</span>

    //                     {row.row.original.payroll_approved &&
    //                     row.row.original.is_pending ? (
    //                       <>
    //                         {/* ///Awaiting for RM approval */}

    //                         {/* Excel Export */}
    //                         {row.row.original?.user_id?.id && (
    //                           <div
    //                             style={{
    //                               display: "flex",
    //                               justifyContent: "center",
    //                               alignItems: "center",
    //                               position: "relative",
    //                             }}
    //                             onMouseEnter={() => setHovered("excel-export")}
    //                             onMouseLeave={() => setHovered(null)}
    //                             onClick={(e) => {
    //                               e.stopPropagation();
    //                               setidforuploaddata({
    //                                 ...getidforupload,
    //                                 user_id: row.row.original.user_id.id,
    //                                 client_id: "",
    //                               });
    //                               setExcelSheetFORKYCPopup(true);
    //                             }}
    //                           >
    //                             <span className="AllformExcel">
    //                               <img
    //                                 src={excelSheetImage}
    //                                 alt="Excel Export"
    //                               />
    //                               {hovered === "excel-export" && (
    //                                 <div
    //                                   className="custom-tooltip"
    //                                   style={{ left: "0" }}
    //                                 >
    //                                   Excel Export
    //                                 </div>
    //                               )}
    //                             </span>
    //                           </div>
    //                         )}
    //                       </>
    //                     ) : (
    //                       ""
    //                     )}
    //                   </div>
    //                 ) : (
    //                   <>
    //                     {/* Completed Status */}
    //                     {!row.row.original.is_pending &&
    //                     !row.row.original.is_decline ? (
    //                       <div className="StatusList">
    //                         <span>---</span>
    //                       </div>
    //                     ) : null}
    //                   </>
    //                 )}
    //               </>
    //             )}
    //           </>
    //         )}
    //       </>
    //     );
    //   },
    // },

    // {
    //   Header: "Download File",
    //   accessor: "",
    //   Cell: (row) => {
    //     return (
    //       <>
    //         <div className="Download-Files">
    //         <i class="fa-solid fa-download"></i>
    //         </div>
    //       </>
    //     );
    //   },
    // },
    // ].filter(Boolean);
  ].filter(Boolean);

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  useEffect(() => {
    if (state.SideBarFiles.SideBarFile == "Overview") {
      dispatch(setTheFROMDATELIST(range[0]));
      dispatch(setTheTODATELISTINDASH(range[1]));
    } else if (state.SideBarFiles.SideBarFile == "Onboard Overview") {
      dispatch(setTheOnboardFromDateLIST(range[0]));
      dispatch(setOnboardTODtaeDASH(range[1]));
    } else if (state.SideBarFiles.SideBarFile == "Approve Request") {
      dispatch(setTheEmployeeLISTfromdate(range[0]));
      dispatch(setEmployeeLstTodate(range[1]));
    }
  }, [range]);
  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    // console.log(value, "vlues");
    setdtPageindex(1);

    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];

  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    // console.log(Counts, values, sel, SelectedValues, "sadsSelectedValues");
    dispatch(
      settheLabourCasualApproveRequestEmployeelist_FilterOptions(
        SelectedValues,
      ),
    );
    setdtPageindex(1);
    setFilterRendersInValues(SelectedValues);
    if (SelectedValues.value == 1) {
      setStatusfilter({
        ...StatusFilter,
        awaiting_payroll: "",
        awaiting_rm: "",
        kyc_completed: true,
        kyc_pending: "",
        is_exited: "",
        is_expired: "",
      });
    } else if (SelectedValues.value == 2) {
      setStatusfilter({
        ...StatusFilter,
        awaiting_payroll: "",
        awaiting_rm: "",
        kyc_completed: "",
        kyc_pending: true,
        is_exited: "",
        is_expired: "",
      });
    } else if (SelectedValues.value == 3) {
      setStatusfilter({
        ...StatusFilter,
        awaiting_payroll: true,
        awaiting_rm: "",
        kyc_completed: "",
        kyc_pending: "",
        is_exited: "",
        is_expired: "",
      });
    } else if (SelectedValues.value == 4) {
      setStatusfilter({
        ...StatusFilter,
        awaiting_payroll: "",
        awaiting_rm: true,
        kyc_completed: "",
        kyc_pending: "",
        is_exited: "",
        is_expired: "",
      });
    } else if (SelectedValues.value == 5) {
      setStatusfilter({
        ...StatusFilter,
        awaiting_payroll: "",
        awaiting_rm: "",
        kyc_completed: "",
        kyc_pending: "",
        is_exited: true,
        is_expired: "",
      });
    } else if (SelectedValues.value == 6) {
      setStatusfilter({
        ...StatusFilter,
        awaiting_payroll: "",
        awaiting_rm: "",
        kyc_completed: "",
        kyc_pending: "",
        is_exited: "",
        is_expired: true,
      });
    } else if (SelectedValues.value == 0) {
      setStatusfilter({
        ...StatusFilter,
        awaiting_payroll: "",
        awaiting_rm: "",
        kyc_completed: "",
        kyc_pending: "",
        is_exited: "",
        is_expired: "",
      });
    }
  };

  const ClearState = (Counts) => {
    if (Counts == 2) {
      setStatusfilter({
        ...StatusFilter,
        awaiting_payroll: "",
        awaiting_rm: "",
        kyc_completed: "",
        kyc_pending: "",
        is_exited: "",
        is_expired: "",
      });
      setdtPageindex(1);
      setFilterRendersInValues({ value: 0, label: "All" });
      dispatch(
        settheLabourCasualApproveRequestEmployeelist_FilterOptions({
          value: 0,
          label: "All",
        }),
      );
    }
  };
  const HandleClientBranches = (selectedVal) => {
    if (selectedVal != null) {
      setClientID({
        ...ClientId,
        client: selectedVal.value,
      });
      dispatch(
        settheLabourCasualApproveRequestEmployeelist_Client(selectedVal),
      );

      dispatch(getSingleEmployeeActions(selectedVal.value)); /// branch=---list
    } else if (selectedVal == null) {
      setClientID({
        ...ClientId,
        client: "",
      });
      dispatch(
        settheLabourCasualApproveRequestEmployeelist_Client({
          value: "",
          label: "ALL",
        }),
      );
      dispatch(getSingleEmployeeActions("")); /// branch=---list
    }
  };
  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage);
  };

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };

  const openMe = () => {
    const rsAnimFade = document.querySelector(".rs-anim-fade");
    if (rsAnimFade) {
      rsAnimFade.style.setProperty("left", "879.344px", "important");
      rsAnimFade.style.setProperty("top", "184.109px", "important");
    }
  };

  const CloseDateRange = () => {
    const rsAnimFade = document.querySelector(".rs-anim-fade");
    if (rsAnimFade) {
      rsAnimFade.style.setProperty("display", "none", "important");
      // rsAnimFade.style.setProperty('top', '184.109px', 'important');
    }
  };
  // console.log(state.SideBarFiles.UserEmailID ,"Login user In (email Id)");
  const currentRef = useRef();
  const scrollPosition = (e) => {
    const val = currentRef.current.scrollTop;
    sessionStorage.setItem("approverequestempTableScrollPosition", val);
  };

  const getZoomFactor = () => {
    const zoom = document.body.style.zoom;
    return zoom ? parseFloat(zoom) / 100 : 1;
  };

  const alignDateRangePicker = (pickerNode) => {
    const picker = pickerNode?.root || pickerNode?.container || pickerNode;

    const popup = document.querySelector(
      ".rs-picker-popup.rs-picker-popup-daterange",
    );

    if (!picker || !popup) return;

    const zoom = getZoomFactor();
    const rect = picker.getBoundingClientRect();

    const popupWidth = popup.offsetWidth;
    const popupHeight = popup.offsetHeight;

    const viewportWidth = window.innerWidth / zoom;
    const viewportHeight = window.innerHeight / zoom;

    const scrollX = window.scrollX / zoom;
    const scrollY = window.scrollY / zoom;

    let left = rect.right / zoom - popupWidth + scrollX;
    let top = rect.bottom / zoom + 8 + scrollY;

    if (left < 8) left = 8;
    if (left + popupWidth > viewportWidth - 8) {
      left = viewportWidth - popupWidth - 8;
    }

    if (top + popupHeight > viewportHeight + scrollY - 8) {
      top = rect.top / zoom - popupHeight - 8 + scrollY;
    }

    popup.style.position = "absolute";
    popup.style.left = `${left}px`;
    popup.style.top = `${top}px`;
  };

  return (
    <>
      <div
        onScroll={scrollPosition}
        ref={currentRef}
        className={stateDisplay ? "outterContent" : "inner-Content"}
      >
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3 class="user-name mb-0">Casual Labour List</h3>
            <br />
          </div>
        </div>

        <div
          className="row Filters  ApproveRequestFilters"
          style={{
            marginRight: "0px",
            marginLeft: "0px",
            padding: "0px 30px",
            zIndex: "89",
          }}
        >
          <div
            className="col-sm-2"
            style={{ marginTop: "-19px", zIndfex: "99" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              State
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              // onClick={(e)=>{setClictedState(true)}}
              onClick={() => setClictedState(true)}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect({ value: "", label: "ALL" });
                console.log(e, "jjk9090");
              }}
              value={multiselect}
              labelledBy="Select"
              // placeholder={"Search"}
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px", zIndex: 3 }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={
                multiselect1
                  ? Array.isArray(multiselect1)
                    ? multiselect1.some(
                        (item) => item.label === "ALL" || item.label === "All",
                      )
                      ? false
                      : true
                    : multiselect1.label === "ALL" ||
                        multiselect1.label === "All"
                      ? false
                      : true
                  : true
              }
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Zone
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              value={multiselect3}
              options={nameList5}
              isClearable={
                multiselect3
                  ? Array.isArray(multiselect3)
                    ? multiselect3.some(
                        (item) => item.label === "ALL" || item.label === "All",
                      )
                      ? false
                      : true
                    : multiselect3.label === "ALL" ||
                        multiselect3.label === "All"
                      ? false
                      : true
                  : true
              }
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>

          <div
            className="col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Organization
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                setdtPageindex(1);
                handlOrganizationList(e);
              }}
              options={Organization_options}
              labelledBy="Select"
              onInputChange={handleInputOrganization}
              isClearable={
                state.EmployeeVerificationsNeed
                  .LabourCasualApproveRequestEmployeelist_Organizations
                  ? Array.isArray(
                      state.EmployeeVerificationsNeed
                        .LabourCasualApproveRequestEmployeelist_Organizations,
                    )
                    ? state.EmployeeVerificationsNeed.LabourCasualApproveRequestEmployeelist_Organizations.some(
                        (item) => item.label === "ALL" || item.label === "All",
                      )
                      ? false
                      : true
                    : state.EmployeeVerificationsNeed
                          .LabourCasualApproveRequestEmployeelist_Organizations
                          .label === "ALL" ||
                        state.EmployeeVerificationsNeed
                          .LabourCasualApproveRequestEmployeelist_Organizations
                          .label === "All"
                      ? false
                      : true
                  : true
              }
              value={
                state.EmployeeVerificationsNeed
                  .LabourCasualApproveRequestEmployeelist_Organizations
              }
            />
          </div>

          <div
            className="col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Client
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                setdtPageindex(1);
                HandleClientBranches(e);
              }}
              options={nameList4}
              filterOption={() => true}
              labelledBy="Select"
              onInputChange={HandleInputBranch}
              isClearable={
                state.EmployeeVerificationsNeed
                  .LabourCasualApproveRequestEmployeelist_Client
                  ? Array.isArray(
                      state.EmployeeVerificationsNeed
                        .LabourCasualApproveRequestEmployeelist_Client,
                    )
                    ? state.EmployeeVerificationsNeed.LabourCasualApproveRequestEmployeelist_Client.some(
                        (item) => item.label === "ALL" || item.label === "All",
                      )
                      ? false
                      : true
                    : state.EmployeeVerificationsNeed
                          .LabourCasualApproveRequestEmployeelist_Client
                          .label === "ALL" ||
                        state.EmployeeVerificationsNeed
                          .LabourCasualApproveRequestEmployeelist_Client
                          .label === "All"
                      ? false
                      : true
                  : true
              }
              value={
                state.EmployeeVerificationsNeed
                  .LabourCasualApproveRequestEmployeelist_Client
              }
            />
          </div>

          <div className="col-sm-2 SelectedDate" style={{ marginTop: "-21px" }}>
            <label
              for="validationCustom01 "
              class="form-label"
              style={{ fontSize: "19px", width: "100%" }}
            >
              Select Date
              <span style={{ color: "red" }}>*</span>
            </label>

            <div className="datepicker_dash">
              <DateRangePicker
                defaultValue={
                  state.EmployeeVerificationsNeed
                    .LabourCasualApproveRequestEmployeelist_From_Date != ""
                    ? [
                        new Date(
                          state.EmployeeVerificationsNeed
                            .LabourCasualApproveRequestEmployeelist_From_Date,
                        ),
                        new Date(
                          state.EmployeeVerificationsNeed
                            .LabourCasualApproveRequestEmployeelist_To_date,
                        ),
                      ]
                    : [new Date(range[0]), new Date(range[1])]
                }
                components={{
                  ClearButton: () => null,
                }}
                //               onOpen={() => {
                //                 openMe()
                //               }}
                // onClose={() => {
                //   CloseDateRange()
                // }}

                ref={dateRangeRef}
                onOpen={() => {
                  setTimeout(() => {
                    alignDateRangePicker(dateRangeRef.current);
                  }, 80);
                }}
                style={{
                  width: "100%",
                  padding: "0px 5px",
                }}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                onChange={(e) => {
                  if (e != null) {
                    setrange([]);
                    e.forEach((newValue) => {
                      var tzoffset = new Date().getTimezoneOffset() * 60000;
                      var localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      handlechangedate(localISOTime);
                    });
                  }
                }}
              />
            </div>
          </div>
        </div>

        <div style={{ padding: " 30px 40px", marginTop: "-13px" }}>
          <ReactTable
            data={
              Array.isArray(state.CasualApproveRequestDatas.Inquriy)
                ? state.CasualApproveRequestDatas.Inquriy
                : []
            }
            columns={columns}
            currentPage={currentPage}
            totalItems={state.CasualApproveRequestDatas.Total_Count}
            onChange={tochange}
            pagesize={pagesize}
            dtpagesize={pageSize}
            pageindex={pageindex}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            datacount={state.CasualApproveRequestDatas.Total_Count}
            dtpageindex={dtpageindex}
            MakeCreate={true}
            ViewParts={(e) => {
              //   handleEmployeeDetails(e);
            }}
            NoFilter={true}
            values={FilterRenderValues}
            options={options}
            Filter={true}
            count={count}
            ClearState={ClearState}
            placeHold={"All"}
            setsno={setsno}
            sno={sno}
            id={"spe"}
            // ApproveRequestFilter={true}
            searchVal={
              TablePositionPersist?.approveRequesTempPage?.search == "" ||
              TablePositionPersist?.approveRequesTempPage?.search == undefined
                ? ""
                : TablePositionPersist.approveRequesTempPage.search
            }
            search_key={true}
          />
        </div>
      </div>

      <>
        {ExcelSheeTFORKYCPopup ? (
          <ExcelFormatDwonload
            show={ExcelSheeTFORKYCPopup}
            setShow={setExcelSheetFORKYCPopup}
            EditID={getidforupload}
          />
        ) : null}
      </>
    </>
  );
};

export default CasualLabourList;
